import axiosInstance from "../axios";

const getFetcher = async (url: string) => {
  try {
    const { data } = await axiosInstance().get(url);
    return data;
  } catch (error: any) {
    // Include status code in the error for better error handling
    const errorData = error.response?.data || {};

    throw {
      ...errorData,
      status: error.response?.status,
      statusText: error.response?.statusText,
    };
  }
};

const getFetcherWithQueryOrRouteParams = async (data: any) => {
  // console.log("getFetcherWithQueryOrRouteParams:", data);
  const { url, args } = data;
  const { queryParameters, routerParameter } = args;

  console.log("queryParameters:", queryParameters);
  console.log("routerParameter:", routerParameter);

  try {
    const { data } = await axiosInstance().get(
      queryParameters
        ? `${url}?${queryParameters}`
        : routerParameter
          ? `${url}?${routerParameter}`
          : url,
    );
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const postFetcher = async (data: any) => {
  const { url, args } = data;
  try {
    const { data } = await axiosInstance().post(url, args);
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const verifyTokenPostFetcher = async (url: any, apiData: any) => {
  try {
    const { data } = await axiosInstance().post(url, apiData);
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const formDataPostFetcher = async (data: any) => {
  const { url, args } = data;
  try {
    const { data } = await axiosInstance().post(url, args, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const formDataPutFetcher = async (url: any, { arg }: any) => {
  try {
    const { data } = await axiosInstance().put(url, arg, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const putFetcher = async (data: any) => {
  const { url, args } = data;
  try {
    const { data } = await axiosInstance().put(url, args);
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const patchFetcher = async (data: any) => {
  const { url, args } = data;

  try {
    const { data } = await axiosInstance().patch(url, args);
    return data;
  } catch (error: any) {
    console.log("Error Patch Fetcher:", error);
    throw error?.response?.data;
  }
};

const deleteFetcher = async (url: string) => {
  try {
    const { data } = await axiosInstance().delete(url);
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

const formDataPatchFetcher = async (data: any) => {
  const { url, args } = data;
  try {
    const { data } = await axiosInstance().patch(url, args, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

export {
  getFetcher,
  getFetcherWithQueryOrRouteParams,
  postFetcher,
  verifyTokenPostFetcher,
  formDataPostFetcher,
  formDataPutFetcher,
  putFetcher,
  patchFetcher,
  deleteFetcher,
  formDataPatchFetcher,
};
